// source: timeline/toolbar/toolbar.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.wisetime.timeline.toolbar.PersistedToolbar', null, global);
goog.exportSymbol('proto.wisetime.timeline.toolbar.TimeBlocksSortOrder', null, global);
goog.exportSymbol('proto.wisetime.timeline.toolbar.TimeRowViewFlag', null, global);
goog.exportSymbol('proto.wisetime.timeline.toolbar.TimelineRowSortType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.timeline.toolbar.PersistedToolbar = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.timeline.toolbar.PersistedToolbar.repeatedFields_, null);
};
goog.inherits(proto.wisetime.timeline.toolbar.PersistedToolbar, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.timeline.toolbar.PersistedToolbar.displayName = 'proto.wisetime.timeline.toolbar.PersistedToolbar';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.timeline.toolbar.PersistedToolbar.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.timeline.toolbar.PersistedToolbar.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.timeline.toolbar.PersistedToolbar.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.timeline.toolbar.PersistedToolbar} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.timeline.toolbar.PersistedToolbar.toObject = function(includeInstance, msg) {
  var f, obj = {
    sortType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    sortOrder: jspb.Message.getFieldWithDefault(msg, 2, 0),
    viewFlagsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.timeline.toolbar.PersistedToolbar}
 */
proto.wisetime.timeline.toolbar.PersistedToolbar.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.timeline.toolbar.PersistedToolbar;
  return proto.wisetime.timeline.toolbar.PersistedToolbar.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.timeline.toolbar.PersistedToolbar} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.timeline.toolbar.PersistedToolbar}
 */
proto.wisetime.timeline.toolbar.PersistedToolbar.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.wisetime.timeline.toolbar.TimelineRowSortType} */ (reader.readEnum());
      msg.setSortType(value);
      break;
    case 2:
      var value = /** @type {!proto.wisetime.timeline.toolbar.TimeBlocksSortOrder} */ (reader.readEnum());
      msg.setSortOrder(value);
      break;
    case 3:
      var values = /** @type {!Array<!proto.wisetime.timeline.toolbar.TimeRowViewFlag>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addViewFlags(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.timeline.toolbar.PersistedToolbar.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.timeline.toolbar.PersistedToolbar.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.timeline.toolbar.PersistedToolbar} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.timeline.toolbar.PersistedToolbar.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSortType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getSortOrder();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getViewFlagsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      3,
      f
    );
  }
};


/**
 * optional TimelineRowSortType sort_type = 1;
 * @return {!proto.wisetime.timeline.toolbar.TimelineRowSortType}
 */
proto.wisetime.timeline.toolbar.PersistedToolbar.prototype.getSortType = function() {
  return /** @type {!proto.wisetime.timeline.toolbar.TimelineRowSortType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.wisetime.timeline.toolbar.TimelineRowSortType} value
 * @return {!proto.wisetime.timeline.toolbar.PersistedToolbar} returns this
 */
proto.wisetime.timeline.toolbar.PersistedToolbar.prototype.setSortType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional TimeBlocksSortOrder sort_order = 2;
 * @return {!proto.wisetime.timeline.toolbar.TimeBlocksSortOrder}
 */
proto.wisetime.timeline.toolbar.PersistedToolbar.prototype.getSortOrder = function() {
  return /** @type {!proto.wisetime.timeline.toolbar.TimeBlocksSortOrder} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.wisetime.timeline.toolbar.TimeBlocksSortOrder} value
 * @return {!proto.wisetime.timeline.toolbar.PersistedToolbar} returns this
 */
proto.wisetime.timeline.toolbar.PersistedToolbar.prototype.setSortOrder = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * repeated TimeRowViewFlag view_flags = 3;
 * @return {!Array<!proto.wisetime.timeline.toolbar.TimeRowViewFlag>}
 */
proto.wisetime.timeline.toolbar.PersistedToolbar.prototype.getViewFlagsList = function() {
  return /** @type {!Array<!proto.wisetime.timeline.toolbar.TimeRowViewFlag>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<!proto.wisetime.timeline.toolbar.TimeRowViewFlag>} value
 * @return {!proto.wisetime.timeline.toolbar.PersistedToolbar} returns this
 */
proto.wisetime.timeline.toolbar.PersistedToolbar.prototype.setViewFlagsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {!proto.wisetime.timeline.toolbar.TimeRowViewFlag} value
 * @param {number=} opt_index
 * @return {!proto.wisetime.timeline.toolbar.PersistedToolbar} returns this
 */
proto.wisetime.timeline.toolbar.PersistedToolbar.prototype.addViewFlags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.timeline.toolbar.PersistedToolbar} returns this
 */
proto.wisetime.timeline.toolbar.PersistedToolbar.prototype.clearViewFlagsList = function() {
  return this.setViewFlagsList([]);
};


/**
 * @enum {number}
 */
proto.wisetime.timeline.toolbar.TimelineRowSortType = {
  CHRONOLOGY: 0,
  REVERSE_CHRONOLOGY: 1,
  DURATION: 2,
  ACTIVITY: 3,
  DESCRIPTION: 4,
  TAG: 5
};

/**
 * @enum {number}
 */
proto.wisetime.timeline.toolbar.TimeBlocksSortOrder = {
  ASCENDING: 0,
  DESCENDING: 1
};

/**
 * @enum {number}
 */
proto.wisetime.timeline.toolbar.TimeRowViewFlag = {
  ERRORED: 0,
  TAGGED: 1,
  UNTAGGED: 2
};

goog.object.extend(exports, proto.wisetime.timeline.toolbar);
